<template>
  <div>
    <v-app>
    <my-asidebar v-bind:active-tab="'district'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">District</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li>İlçe</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-item p-3">

            <v-data-table
                :headers="headers"
                :items="districtList"
                :items-per-page="5"
                class="elevation-1">
              <template v-slot:top>
                <v-toolbar
                    flat>
                  <v-toolbar-title>İlçeler</v-toolbar-title>
                  <v-divider
                      class="mx-4"
                      inset
                      vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog
                      v-model="dialog"
                      max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          color="primary"
                          dark
                          class="mb-2"
                          v-bind="attrs"
                          @click="editedItem = Object.assign({},defaultItem)"
                          v-on="on">
                        <i class="la la-plus mr-1"></i>
                        Yeni İlçe Yarat
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                                cols="12"
                                sm="6"
                                md="4">
                              <v-text-field
                                  v-model="editedItem.name"
                                  label="İlçe Adı"
                              ></v-text-field>
                              <v-autocomplete :filter="filterCities"
                                              :items="cityList"
                                              v-model="editedItem.cityId"
                                              label="Şehir"
                                              flat hide-no-data
                                              hide-details
                                              item-value="id"
                                              placeholder="Şehir">
                                <template slot="selection" slot-scope="{ item, selected }">
                                  {{item.name}}
                                </template>
                                <template slot="item" slot-scope="{ item, tile }">
                                  <v-list-tile-content>
                                    {{item.name}}
                                  </v-list-tile-content>
                                </template>
                              </v-autocomplete>
                              <v-text-field
                                  v-model="editedItem.code2"
                                  label="Code 2"
                              ></v-text-field>
                              <v-text-field
                                  v-model="editedItem.code3"
                                  label="Code 3"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close">
                          Cancel
                        </v-btn>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="save">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.name="{ item }">
                <tr>
                  {{ item.name }}
                </tr>
              </template>
              <template v-slot:item.cityId="{ item }">
                <tr>
                  {{ getCityName(item.cityId) }}
                </tr>
              </template>
              <template v-slot:item.actions="{ item }">
                <div class="row">
                  <div class="table-content mr-2" v-on:click="deleteItem(item)">
                    <div class="theme-btn theme-btn-small">
                      <i class="la la-trash"></i>
                    </div>
                  </div>
                  <div class="table-content" @click="editItem(item)">
                    <div class="theme-btn theme-btn-small">
                      <i class="la la-edit"></i>
                    </div>
                  </div>
                </div>
<!--                <v-icon-->
<!--                    small-->
<!--                    class="mr-2"-->
<!--                    @click="editItem(item)"-->
<!--                >-->
<!--                  mdi-pencil-->
<!--                </v-icon>-->
<!--                <v-icon-->
<!--                    small-->
<!--                    @click="deleteItem(item)"-->
<!--                >-->
<!--                  mdi-delete-->
<!--                </v-icon>-->
              </template>
            </v-data-table>
        </div>
      </div>
    </section>
    </v-app>
  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import FormList from "../component/form/FormList";

import messagePopupManager from "../util/messagePopupManager";
import city from "../store/module/city";

export default {
  name: "DistrictListPage",
  components: {FormList, MyAsidebar, TopBar},
  data () {
    return {
      districtList: [],
      dialog: false,
      dialogDelete: false,
      cityList: [],
      cityMap: null,
      editedItem: {
        cityId : 0,
        name: '',
        code2: '',
        code3: '',
      },
      defaultItem: {
        cityId: 0,
        name: '',
        code2: '',
        code3: '',
      },
      headers: [
        {
          text: 'Adı',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Şehir',
          sortable: true,
          value: 'cityId',
        },
        {
          text: 'Kod2',
          sortable: true,
          value: 'code2',
        },
        {
          text: 'Kod3',
          sortable: true,
          value: 'code3',
        },
        {
          text: 'actions',
          value: 'actions',
        }
      ]
    }
  },
  computed:{
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  methods:{
    editItem (item) {
      this.editedIndex = this.districtList.indexOf(item)
      this.editedItem = Object.assign({}, item);
      this.dialog = true
    },

    deleteItem (item) {
      this.editedItem = Object.assign({}, item)
      messagePopupManager.showDeleteQuestion(() => {
        this.$store.dispatch("deleteDistrict",this.editedItem).then(()=>{
          this.districtList.splice(this.districtList.indexOf(item), 1);
        })
        .catch(error => {
          messagePopupManager.showError();
        })
      })
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedIndex = -1
      })
    },
    save () {
      if (this.editedIndex > -1) {
        this.$store.dispatch("updateDistrict", this.editedItem).then(()=>{
            this.districtList.splice(this.editedIndex, 1);
            this.districtList.push(Object.assign({}, this.editedItem));
            }).catch(error => {
              messagePopupManager.showError();
            })
      } else {
        this.$store.dispatch("createDistrict", this.editedItem).then((response)=>{
          this.editedItem.id = response.id;
          this.districtList.push(this.editedItem);
        }).catch(error => {
          messagePopupManager.showError();
        })
      }
      this.close()
    },
    filterCities(row, searchTerm){
      if(row.name.includes(searchTerm) || row.code2.includes(searchTerm) || row.code3.includes(searchTerm)){
        return true;
      }
      return false;
    },
    getCityName(id){
      if(this.cityMap === null) return "";
      if(this.cityId === 0) return "";
      return this.cityMap[id].name;
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_DISTRICT_LIST"]) this.$router.push("/");

    this.$store.dispatch("loadDistrictList").then((districtList) => {
      this.districtList = districtList;
    });

    this.$store.dispatch("loadCityList").then((cityList) => {
      this.cityList = cityList;
      this.cityMap = cityList.reduce(function (map, city) {
        map[city.id] = city;
        return map;
      }, {});
    });

  }
}
</script>

<style scoped>

</style>